import { useAuth, useCollection } from '@hb/react'
import {
  ConsentForm,
  consentFormTemplatesCollection,
  getMissingConsentForms,
  getPracticeConsentFormsCollection,
  objectToArray,
  PopulatedAssessment,
} from '@hb/shared'
import { useMemo } from 'react'

export const useMissingConsentForms = (
  assessment: PopulatedAssessment | null,
  consentForms: Record<string, ConsentForm> | null | undefined,
) => {
  const { midwifeId: practiceId } = assessment ?? {}
  const { accessLevel } = useAuth()
  const { itemsMap: hbConsentForms } = useCollection(consentFormTemplatesCollection)

  const practiceConsentFormsCollection = useMemo(
    () => (practiceId ? getPracticeConsentFormsCollection(practiceId) : null),
    [practiceId],
  )
  const { itemsMap: practiceConsentForms } = useCollection(practiceConsentFormsCollection)

  return useMemo(
    () =>
      assessment && accessLevel === 'admin'
        ? getMissingConsentForms(
            assessment,
            hbConsentForms,
            practiceConsentForms,
            objectToArray(consentForms ?? {}),
          )
        : [],
    [assessment, hbConsentForms, practiceConsentForms, consentForms, accessLevel],
  )
}
